import { render, staticRenderFns } from "./DetailsDataFieldLabel.vue?vue&type=template&id=7d8c2898&scoped=true"
import script from "./DetailsDataFieldLabel.vue?vue&type=script&lang=ts"
export * from "./DetailsDataFieldLabel.vue?vue&type=script&lang=ts"
import style0 from "./DetailsDataFieldLabel.vue?vue&type=style&index=0&id=7d8c2898&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d8c2898",
  null
  
)

export default component.exports